import { MdBedroomParent } from "react-icons/md";
import { ValidationContext, defineField, defineType } from "sanity";

const isUniqueCode = (code: string | undefined, context: ValidationContext) => {
  const { document, getClient } = context;
  if (!document || !code) return false;

  const client = getClient({ apiVersion: "2022-12-07" });

  const id = document._id.replace(/^drafts\./, "");

  /* groq */
  const query = `!defined(*[
    _type == 'suiteClassGroup' &&
    !(_id in [$draft, $published]) &&
    code == $code
  ][0]._id)`;

  return client.fetch(query, {
    draft: `drafts.${id}`,
    published: id,
    code
  });
};

export default defineType({
  name: "suiteClassGroup",
  title: "Suite Class Group",
  type: "document",
  icon: MdBedroomParent,
  orderings: [
    {
      title: "By Code",
      name: "codeAsc",
      by: [{ field: "code", direction: "asc" }]
    }
  ],
  preview: {
    select: { title: "code" }
  },
  fields: [
    defineField({
      name: "code",
      title: "Code",
      description:
        "this is the code that groups the same suite class with different validity date",
      type: "string",
      validation: (Rule) =>
        Rule.required().custom(async (value: string | undefined, context) => {
          const isUnique = await isUniqueCode(value, context);
          if (!isUnique)
            return "Another suite class group with this code is present";
          return true;
        })
    })
  ]
});
